const nativeDocumentWrite = document.write
let documentWriteContext = null

document.write = content => {
	if (documentWriteContext) {
		documentWriteContext.innerHTML += content
	} else {
		nativeDocumentWrite.call(document, arguments)
	}
}

export default function hookWrite (context) {
	documentWriteContext = context
}
